export const getParamsUrl = (filterSettingsArr, filterSettingsMass) => {
  const paramsURL = new URLSearchParams();
  filterSettingsArr.forEach((item) => {
    switch (item) {
      case "ids":
        paramsURL.append(
          `dealerSearch[${item}]` + "[]",
          filterSettingsMass[item],
        );
        break;
      case "ivideonAuthorized":
        paramsURL.append(`${item}`, filterSettingsMass[item]);
        break;
      case "ownerName":
        paramsURL.append(`${item}`, filterSettingsMass[item]);
        break;
      case "ivideonOwnerName":
        paramsURL.append(`${item}`, filterSettingsMass[item]);
        break;
      case "serviceAccept":
        paramsURL.append(`${item}`, filterSettingsMass[item]);
        break;
      case "saleAccept":
        paramsURL.append(`${item}`, filterSettingsMass[item]);
        break;
      case "checkStatus":
        paramsURL.append(`${item}`, filterSettingsMass[item]);
        break;
      case "status":
        paramsURL.append(`status[]`, filterSettingsMass[item]);
        break;
      case "extendedForNextYear":
        paramsURL.append(`extendedForNextYear`, filterSettingsMass[item]);
        break;
      default:
        paramsURL.append(`dealerSearch[${item}]`, filterSettingsMass[item]);
    }
  });
  return paramsURL.toString();
};
